import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import type { FileTypesCategory } from '../accepted-file-types/accepted-file-types.types';
import { FileHandlerDefaultValidatorDirective } from './file-handler-default-validator.directive';
import type { FileReadResult } from './file-handler.directive';
import { FileHandlerDirective } from './file-handler.directive';

@Component({
  selector: 'rt-file-handler',
  template: `<div
    rtFileHandler
    rtFileHandlerDefaultValidator
    [rtFileHandlerValidateMaxSize]="true"
    [rtFileHandlerMultiple]="multiple"
    [rtFileHandlerAccept]="accept"
    (rtFileHandlerNextFile)="nextFile.emit($any($event))"
    hidden
  ></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileHandlerDirective, FileHandlerDefaultValidatorDirective],
})
export class FileHandlerComponent {
  @Input()
  public validateMaxSize = false;

  @Input()
  public multiple = false;

  @Input()
  public accept: FileTypesCategory;

  @Output()
  public nextFile: EventEmitter<FileReadResult> = new EventEmitter<FileReadResult>();

  @ViewChild(FileHandlerDirective)
  public instance: FileHandlerDirective;
}
